export default __webpack_public_path__ + "static/media/prev-Marine-Receiver-6.4a07332c.png";